module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7d5856cb1fc9aba2ec4134627375dffc.png";